<div class="row">
    <div class="col-lg-4">
        <div class="card block">
            <div class="card-header">
                <div class="card-title">
                    <h2>Vos revenus</h2>
                </div>
            </div>
            <div class="card-body col-md-12">
                <div class="card-text row">
                    <div class="col-12">
                        <mat-form-field>
                            <mat-label>Salaire mensuel net</mat-label>
                            <input matInput [(ngModel)]="form.salary" (keyup.enter)="simulate()">
                            <span matSuffix>€/mois</span>
                        </mat-form-field>
                    </div>
                    <div class="col-12">
                        <mat-form-field>
                            <mat-label>Revenus locatifs actuels HC</mat-label>
                            <input matInput [(ngModel)]="form.today_rental_revenues" (keyup.enter)="simulate()">
                            <span matSuffix>€/mois</span>
                        </mat-form-field>
                    </div>
                    <div class="col-12">
                        <mat-form-field>
                            <mat-label>Autres revenus</mat-label>
                            <input matInput [(ngModel)]="form.other_incomes" (keyup.enter)="simulate()">
                            <span matSuffix>€/mois</span>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-lg-4">
        <div class="card block">
            <div class="card-header">
                <div class="card-title">
                    <h2>Vos charges</h2>
                </div>
            </div>
            <div class="card-body col-md-12">
                <div class="card-text row">
                    <div class="col-12">
                        <mat-form-field>
                            <mat-label>Loyer personnel</mat-label>
                            <input matInput [(ngModel)]="form.personnal_rent" (keyup.enter)="simulate()">
                            <span matSuffix>€/mois</span>
                        </mat-form-field>
                    </div>
                    <div class="col-12">
                        <mat-form-field>
                            <mat-label>Mensualités de crédit en cours</mat-label>
                            <input matInput [(ngModel)]="form.today_loan_monthly_payement" (keyup.enter)="simulate()">
                            <span matSuffix>€/mois</span>
                        </mat-form-field>
                    </div>
                    <div class="col-12">
                        <mat-form-field>
                            <mat-label>Autres charges</mat-label>
                            <input matInput [(ngModel)]="form.other_expenses" (keyup.enter)="simulate()">
                            <span matSuffix>€/mois</span>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-lg-4">
        <div class="card block">
            <div class="card-header">
                <div class="card-title">
                    <h2>Votre investissement</h2>
                </div>
            </div>
            <div class="card-body col-md-12">
                <div class="card-text row">
                    <div class="col-12">
                        <mat-form-field>
                            <mat-label>Rendement brut ciblé</mat-label>
                            <input matInput [(ngModel)]="form.gross_return" (keyup.enter)="simulate()">
                            <span matSuffix>%</span>
                        </mat-form-field>
                    </div>
                    <div class="col-12">
                        <mat-form-field>
                            <mat-label>Durée du prêt</mat-label>
                            <input matInput [(ngModel)]="form.loan_maturity" (keyup.enter)="simulate()">
                            <span matSuffix>ans</span>
                        </mat-form-field>
                    </div>
                    <div class="col-12">
                        <mat-form-field>
                            <mat-label>Taux d'intérêt</mat-label>
                            <input matInput [(ngModel)]="form.loan_rate" (keyup.enter)="simulate()">
                            <span matSuffix>%</span>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-12 text-center mb-4">
        <button class="btn btn-lg" (click)="simulate()" [disabled]="loading">
            <i class="fa fa-calculator"></i> Calculer ma capacité d'emprunt
        </button>
    </div>
</div>

<div class="row" *ngIf="loading">
    <div class="col-12 mb-4">
        <mat-spinner diameter="50" color="second" class="mx-auto"></mat-spinner>
    </div>
</div>

<ng-container *ngIf="!loading && status !== ''">
    <div class="row" *ngIf="status !== 'success'">
        <div class="col-12 mb-4">
            <div class="info-box info-box-warning" *ngIf="status === 'debt'">
                <i class="fa fa-exclamation-triangle"></i>
                <span>
                    Votre taux d'endettement actuel est de <b>{{ result.today_debt_rate * 100 | number:'1.0-0' }} %</b>,
                    ce qui est supérieur à la limite de <b>35 %</b> imposée par le HCSF (Haut Conseil de Stabilité Financière).
                    Il faudra donc défendre votre dossier pour obtenir une dérogation bancaire.
                </span>
            </div>
            <div class="info-box info-box-warning" *ngIf="status === 'fail'">
                <i class="fa fa-exclamation-triangle"></i>
                <span>
                    <b>Votre simulation n'a pas abouti.</b>
                    Vérifiez que les valeurs utilisées sont réalistes : rendement ciblé, durée du prêt, taux d'intérêt…
                </span>
            </div>
            <div class="info-box info-box-warning" *ngIf="status === 'error'">
                <i class="fa fa-exclamation-triangle"></i>
                <span>Une erreur est survenue, merci de corriger votre saisie.</span>
            </div>
        </div>
    </div>

    <div class="row kpi" *ngIf="status === 'success'">
        <div class="col-6 col-lg-3">
            <div class="card kpi-green">
                <div class="card-body kpi-card">
                    <h5 class="card-title">Capacité d'emprunt</h5>
                    <p class="card-value">{{ result.borrowing_capacity | number:'1.0-0' }} <span class="fs-7"> €</span></p>
                </div>
            </div>
        </div>
        <div class="col-6 col-lg-3">
            <div class="card kpi-blue">
                <div class="card-body kpi-card">
                    <h5 class="card-title">Mensualité de prêt</h5>
                    <p class="card-value">{{ result.loan_monthly_payement | number:'1.0-0' }} <span class="fs-7"> €/mois</span></p>
                </div>
            </div>
        </div>
        <div class="col-6 col-lg-3">
            <div class="card kpi-purple">
                <div class="card-body kpi-card">
                    <h5 class="card-title">Revenus locatifs du bien</h5>
                    <p class="card-value">{{ result.future_location_revenus | number:'1.0-0' }} <span class="fs-7"> €/mois</span></p>
                </div>
            </div>
        </div>
        <div class="col-6 col-lg-3">
            <div class="card kpi-orange">
                <div class="card-body kpi-card">
                    <h5 class="card-title">Taux d'endettement
                        <i class="fa fa-question-circle" matTooltipClass="tooltip-button"
                           matTooltip="Avant l'achat : {{ result.today_debt_rate * 100 | number:'1.0-0' }} %. Limite imposée par le HCSF : 35 %."></i>
                    </h5>
                    <p class="card-value">{{ result.future_debt_rate * 100 | number:'1.0-0' }} <span class="fs-7"> %</span></p>
                </div>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="status === 'success'">
        <div class="col-12">
            <div class="card block">
                <div class="card-header">
                    <div class="card-title">
                        <h2>Calcul de la banque</h2>
                    </div>
                </div>
                <div class="card-body col-md-12">
                    <div class="card-text row">
                        <div class="col-md-6">
                            Taux d'endettement avant achat : <b>{{ result.today_debt_rate * 100 | number:'1.0-0' }} %</b><br/>
                            Taux d'endettement après achat : <b>{{ result.future_debt_rate * 100 | number:'1.0-0' }} %</b>
                        </div>
                        <div class="col-md-6">
                            Revenus totaux retenus : <b>{{ result.revenus_for_bank | number:'1.0-0' }} €/mois</b><br/>
                            Charges totales : <b>{{ result.charges_for_bank | number:'1.0-0' }} €/mois</b>
                        </div>
                        <div class="col-12">
                            <p class="text-muted fs-small mt-3 mb-0">
                                La banque ne retient généralement que 70 % des revenus locatifs, actuels et futurs.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
